<template>
  <comparison-graph :date-range="dateRange" :biz="biz" api-endpoint="reviews-breakdown"/>
</template>

<script>
  import ComparisonGraph from './ComparisonGraph'

  export default {
    name: 'ReviewsCompare',
    components: {ComparisonGraph},
    props: {
      dateRange: {
        type: Object,
        required: true
      },
      biz: {
        type: Array,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/competitors/ReviewsCompare.vue